import { PropertyObjectTypesIds } from 'ui-forms-components/constants/PropertyObjectTypes';
import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { PropertyType } from 'FormsUI/lib/Property';
import { UnknownProperties } from 'forms-utils-lib/constants/Properties';
import FormFieldKeys from 'forms-utils-lib/constants/formField/FormFieldKeys';
import { i18nLookupAndText } from 'FormsUI/utils/FormFieldsUtils';
import { getFormsLangToLang } from 'FormsUI/utils/Lang';
const getUnknownObjects = formLanguage => {
  const localeOptions = {
    locale: getFormsLangToLang(formLanguage)
  };
  return {
    [PropertyObjectTypesIds.UNKNOWN]: {
      [UnknownProperties.PAYMENT_LINK]: {
        [FormFieldKeys.NAME]: UnknownProperties.PAYMENT_LINK,
        [FormFieldKeys.OBJECT_TYPE_ID]: PropertyObjectTypesIds.UNKNOWN,
        [FormFieldKeys.LABEL]: i18nLookupAndText('miscFormFieldLabels.paymentLink', localeOptions),
        [FormFieldKeys.GROUP_NAME]: '',
        [FormFieldKeys.FIELD_TYPE]: FieldTypes.PAYMENT_RADIO,
        [FormFieldKeys.TYPE]: PropertyType.ENUMERATION,
        [FormFieldKeys.OPTIONS]: [],
        [FormFieldKeys.HIDDEN]: true
      }
    }
  };
};
export default getUnknownObjects;